import { PackageFilter } from '../packages/package-filter'

export enum StorageOperationType {
  CHECK_IN = 'CHECK_IN',

  RETRACT = 'RETRACT',

  CHECK_OUT = 'CHECK_OUT',

  MOVE = 'MOVE',
}

export class NewStorageOperation {
  public static checkIn(checkIn: NewStorageOperation.CheckIn): NewStorageOperation {
    return new NewStorageOperation(StorageOperationType.CHECK_IN, checkIn, null, null, null)
  }

  public static retract(retraction: NewStorageOperation.Retraction): NewStorageOperation {
    return new NewStorageOperation(StorageOperationType.RETRACT, null, retraction, null, null)
  }

  public static checkOut(checkOut: NewStorageOperation.CheckOut): NewStorageOperation {
    return new NewStorageOperation(StorageOperationType.CHECK_OUT, null, null, checkOut, null)
  }

  public static move(movement: NewStorageOperation.Movement): NewStorageOperation {
    return new NewStorageOperation(StorageOperationType.MOVE, null, null, null, movement)
  }

  constructor(
    public type: StorageOperationType,
    public checkIn?: NewStorageOperation.CheckIn,
    public retraction?: NewStorageOperation.Retraction,
    public checkOut?: NewStorageOperation.CheckOut,
    public movement?: NewStorageOperation.Movement
  ) {}
}

export namespace NewStorageOperation {
  export class CheckIn {
    constructor(
      public mode: CheckInMode,
      public storageGroupId: string,
      public packages: string[],
      public baseLocation: string,
      public targetLocation?: string
    ) {}
  }

  export class Retraction {
    constructor(public packages: string[]) {}
  }

  export class CheckOut {
    constructor(public packages: string[]) {}
  }

  export class Movement {
    constructor(
      public packageFilter: PackageFilter,
      public targetLocation: string
    ) {}
  }

  export enum CheckInMode {
    PREVIEW = 'PREVIEW',

    CONFIRMING = 'CONFIRMING',
  }
}
